import { Key } from "react"

export const hasValidSelectedRowKeys = (keys?: Key[]): boolean =>
  Array.isArray(keys) && typeof keys.length === "number"

export const isAllSelectedRowKeys = (
  selectedKeys?: Key[],
  dataSource?: unknown[],
): boolean =>
  Array.isArray(selectedKeys) &&
  Array.isArray(dataSource) &&
  selectedKeys.length > 0 &&
  selectedKeys.length === dataSource.length
